import { render, staticRenderFns } from "./WashStandOptions.vue?vue&type=template&id=3d40e282&lang=pug&"
import script from "./WashStandOptions.vue?vue&type=script&lang=js&"
export * from "./WashStandOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports